"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorWithRedirect = exports.handleAuthenticationRedirect = exports.getCurrentUrlWithoutContextPath = void 0;
const URL_PARAM_LENGTH_LIMIT = 1200;
const isAuthenticationError = (errorCode) => [401, 403].includes(errorCode);
const getCurrentUrlWithoutContextPath = () => {
    const url = window.location.pathname.replace(currentContextPath, "");
    // reduce Request header length
    if (window.location.search.length > URL_PARAM_LENGTH_LIMIT) {
        return url;
    }
    return url + window.location.search;
};
exports.getCurrentUrlWithoutContextPath = getCurrentUrlWithoutContextPath;
const handleAuthenticationRedirect = (error) => {
    var _a, _b, _c;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) && isAuthenticationError(error.response.status)) {
        const url = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.redirectUrl;
        window.location.href = url || `${currentContextPath}/my-account/sign-in/`;
    }
};
exports.handleAuthenticationRedirect = handleAuthenticationRedirect;
const handleErrorWithRedirect = (axiosError) => {
    var _a, _b;
    if (!((_a = axiosError.config) === null || _a === void 0 ? void 0 : _a.handleErrorWithRedirect)) {
        return;
    }
    const statusCode = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.status;
    if (statusCode === 500) {
        window.location.replace(`${currentContextPath}/error/500/`);
    }
    if (statusCode === 404) {
        window.location.replace(`${currentContextPath}/error/404/`);
    }
};
exports.handleErrorWithRedirect = handleErrorWithRedirect;
